import { Component, OnDestroy, OnInit } from '@angular/core';
import { ExternalModalViewModel } from '../../view-models/modal/external-modal-view-model';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom } from 'rxjs';
import { IframeLoadedEvent, ModalComponentInterface, StatusMessageInterface } from '@nts/std/interfaces';
import { IframeComponent } from '../iframe/iframe.component';

@Component({
  selector: 'nts-external-modal-container',
  templateUrl: 'external-modal-container.component.html',
  styleUrls: ['./external-modal-container.component.scss'],
  standalone: true,
  imports: [
    IframeComponent
  ]
})

export class ExternalModalContainerComponent implements OnInit, ModalComponentInterface, OnDestroy {

  viewModel: ExternalModalViewModel;
  inIframe: boolean = false;
  iframeLoaded: BehaviorSubject<IframeLoadedEvent> = new BehaviorSubject<IframeLoadedEvent>(null);
  url: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams['iframe'] != null) {
      this.inIframe = this.route.snapshot.queryParams['iframe'] === 'true';
    }
    this.viewModel.initialize(async (iframeUrl: string) => {
      this.url = iframeUrl;

      // Wait for iframe to load
      await firstValueFrom(this.iframeLoaded.pipe(filter(x => x != null)), { defaultValue: null });

      return this.iframeLoaded.value;
    });
  }

  ngOnDestroy(): void {
    this.viewModel = null;
    this.inIframe = null;
    this.iframeLoaded?.complete();
    this.iframeLoaded = null;
    this.url = null;
  }

  onStatusPush(status: StatusMessageInterface): void {
    if (this.viewModel && typeof this.viewModel.onStatusPush === 'function') {
      this.viewModel.onStatusPush(status);
    }
  }
}
